/**
 * Superficie pública Cash.
 * Layered APIs — prefer these from outside the module to avoid require cycles:
 *   infra-api: repos, signals, RPC ports
 *   app-api: labels, utils, shared tab chrome
 * public-api re-exports both + screen entry.
 */
/**
 * Superficie pública Cash.
 * Layered APIs — prefer these from outside the module to avoid require cycles:
 *   domain-api: tipos + reads puros (OK desde reports)
 *   infra-api: resolve, signals, cache invalidation
 *   app-api: labels / utils
 *   ui-api: tab chrome Caja (`CashUnderlineTabBar`); Equipo usa `shared/ui/UnderlineTabBar`
 */
export * from './infra-api';
export * from './app-api';
export * from './labels-api';
export * from './ui-api';

export { CashManagementScreen } from './screens/CashManagementScreen';
